import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { XhsPostType } from '@anytag/graphql';
import { TextSearchField, SelectorField } from '@anytag/shared-molecules';
import { InfluencerXhsPostsFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <TextSearchField<InfluencerXhsPostsFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.PostsInsightFilter')}
      />
      <SelectorField<InfluencerXhsPostsFilterFormKeys>
        name="postType"
        onSubmit={onSubmit}
        className="max-w-50"
        placeholder={t<string>('Sponsored Posts')}
        options={[
          { value: XhsPostType.SPONSORED, label: t('Sponsored Post') },
          { value: XhsPostType.NORMAL, label: t('Normal Post') }
        ]}
        multiple
      />
    </Form.Fields>
  );
};
